module.exports = __webpack_public_path__ + "static/media/detached_orange.67c66baf.svg";